<template>
    <div>
    <b-form-group id="input-group-5" :label="labelVal" label-for="label" :class="uploadFileCss ? 'upload-files' : ''">
        <b-form-file id="profile-picture" ref="file" v-bind="$attrs" :placeholder="placeholderVal"
            drop-placeholder="Drop file here..." :accept="acceptFile" @change="uploadImage"></b-form-file>
        <slot></slot>
    </b-form-group>
    <b-form-group>
        <!-- <p v-if="errorFile!=''">Your last bulk upload encountered errors in some records, specifically in the date fields. Kindly download the file, fix the errors, and re-upload it as those records were not uploaded into the system. <a :href="errorFile">click to download</a></p> -->

    </b-form-group>
</div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import request from "@/utils/request";
const apiUrl = process.env.VUE_APP_API_URL
export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: {
        type: {
            type: String,
            required: true,
        },
        labelVal: {
            type: String,
        },
        placeholderVal: {
            type: String,
            default: 'Choose file to upload',
        },
        acceptFile: {
            type: String,
            default:
                '.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/*',
        },
        uploadFileCss: {
            type: Boolean,
            default: null,
        },
        importFileRun: {
            type: Boolean,
            default: false,
        },
        size: {
            type: Number,
            default: 10,
        },
    }, // End of Component > props

    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {
            uploadPercentage: 0,
            inProgress: false,
            errorFile:"",
        }
    }, // End of Component > data

    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        ...mapGetters(['user', 'dataSegmentId', 'formBuilderList', 'loading']),
    }, // End of Component > mounted
    watch: {
        imagePreviewURL(value) {
            this.previewImage = value
        },
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    async mounted() {
        this.$refs.file.reset()
        await this.getProgress(true)
    }, // End of Component > computed

    /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
    methods: {
        //Upload image
        async uploadImage(e) {

            if (this.inProgress) {
                this.$store.commit('setSuccess', 'Bulk Upload is already in process')
                return
            }


            let self = this
            this.$store.commit('setFileLoading', true)
            this.$store.commit('setLoading', true)

            const file = e.target.files[0]
            if (!this.validateFileType(file, this.acceptFile)) {
                this.$store.commit('setLoading', false)
                this.$toasted.show(
                    `File format is not allowed`,
                    {
                        duration: 3000,
                        type: ['error'],
                    }
                )// Reset placeholder to default since the file is invalid
                this.placeholderVal = 'Choose file to upload';
                this.$refs.file.reset(); // Reset the file input field
                return false;
            }

            try {
                let formData = new FormData()
                if (file) {
                    const originalName = file.name
                    /*
                        Add the form data we need to submit
                    */

                    formData.append('type', this.type)
                    formData.append('file', file)

                    if (this.formatBytes(file.size)) {
                        this.$toasted.show(
                            `File size must be less than ${this.size} MB`,
                            {
                                duration: 3000,
                                type: ['error'],
                            }
                        )
                        return false
                    }

                    let response = await axios.post(
                        apiUrl + 'files/',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },

                            onUploadProgress: function (progressEvent) {
                                // this.uploadPercentage = parseInt(
                                //     Math.round(
                                //         (progressEvent.loaded /
                                //             progressEvent.total) *
                                //             100
                                //     )
                                // )
                                // if (
                                //     this.uploadPercentage < 98 &&
                                //     this.importFileRun
                                // ) {
                                //     self.$emit(
                                //         'show-progress',
                                //         this.uploadPercentage
                                //     )
                                // }
                            },
                        }
                    )
                    response.data.data.originalName = originalName
                    this.$emit('set-value', response.data.data)
                    if (this.importFileRun && this.type === 'bulkCustomersOnboarding') {
                        console.log("for bulkCustomersOnboarding")
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId
                        let resp = await axios.post(
                            apiUrl + 'customers/etl-transform',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                        if (resp && resp.data) {
                            if (resp.data.success) {
                                this.$store.commit('setSuccess', resp.data.message)
                                this.$emit('uploaded', true);
                                await this.getProgress()
                            }
                            else {
                                this.$store.commit('setError', resp.data.message)
                            }

                        }
                    }
                    else if (this.importFileRun && this.type !== 'deltaListUploading') {
                        console.log("NOT for delta")
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId
                        await axios.post(
                            apiUrl + 'screening-data/import/',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                        this.$emit('show-progress', 100)
                    }

                    else if (this.type === 'deltaListUploading') {
                        console.log("for delta")
                        let filename = response.data.data.fileName
                        let obj = {}
                        obj.fileName = filename
                        obj.dataSegmentId = this.dataSegmentId
                        await axios.post(
                            apiUrl + 'screening-data/importDelta/',
                            obj,
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'vueauth_token'
                                    )}`,
                                },
                            }
                        )
                    }
                    this.$emit('uploaded', true);
                    this.$toasted.show(response.data.message, {
                        duration: 3000,
                        type: ['success'],
                    })
                }
            } catch (error) {
                console.log(error)
                // this.$store.commit('setError', error)
            }
            this.$store.commit('setFileLoading', false)
            this.$store.commit('setLoading', false)

        }, // End of upload image function

        formatBytes(bytes) {
            return (
                (bytes / 1048576).toFixed(3) >
                (typeof this.size != 'undefined' ? this.size : 20)
            )
        }, // End of formatBytes function
        async getProgress(onLoad = false) {
            this.inProgress = true
            let { data } = await request.get('users/bulkUploadProgress?onLoad=' + onLoad)
            if (data && data.data) {
            if(onLoad)
            {
                this.errorFile = process.env.VUE_APP_API_URL +'files/bulk-error/' +data.data.errorFileName
            }
                this.$emit('show-progress', data.percentage)
                if (data.percentage < 100 && data.status) {
                    setTimeout(async () => {
                        await this.getProgress();
                    }, 5000);
                } else {
                    this.$emit('show-progress', data.percentage)
                    this.$store.commit('setSuccess', 'Bulk Upload Completed at ' + data.data.createdAt)
                    setTimeout(async () => {
                        this.$emit('show-progress', 0)
                        this.inProgress = false
                    }, 2000);
                }
            }
            else {
                this.inProgress = false
            }

        },
        validateFileType(file, acceptFile) {
            if (!file || !file.type) {
                console.error("Error: File or file type is missing.");
                return false;
            }

            // Split the acceptFile string by commas to create an array of acceptable types/extensions
            const acceptedTypes = acceptFile.split(',');

            // Get the file extension from the name
            const fileExtension = file.name.split('.').pop().toLowerCase();

            // Check if file.type is directly in the list of accepted types or matches image/*
            const isTypeValid = acceptedTypes.some(type => {
                if (type === file.type) {
                    return true; // Direct MIME type match
                }

                if (type === "image/*" && file.type.startsWith("image/")) {
                    return true; // Handle image/* pattern
                }

                // Check if it's a file extension (starts with a dot) and matches the file's extension
                if (type.startsWith('.') && fileExtension === type.substring(1)) {
                    return true;
                }

                return false;
            });

            if (!isTypeValid) {
                console.error(`Error: The file type ${file.type} or extension .${fileExtension} is not accepted. Accepted types are: ${acceptFile}.`);
                return false;
            }

            console.log("File type is valid.");
            return true;
        }
    },
} // End of export default
</script>
